/**
 * Drie weergavevarianten van een circuit-info-tekst. Komen exact overeen met
 * de markdown-bestanden in `docs/human-design/rave-abc/circuits/` (na de
 * angular.json asset-mapping worden ze geserveerd onder
 * `/assets/docs/human-design/circuits/{lang}/{key}_{variant}.md`).
 *
 *  - `compact`  — beknopt overzicht (~250-350 woorden). Snel-leesbaar.
 *  - `normal`   — hybride beschrijving (~700-1100 woorden). Default voor dialogs.
 *  - `extended` — volledige tekst in auteursstem (~1800-2500 woorden). Full-page.
 */
export type HdCircuitInfoVariant = 'compact' | 'normal' | 'extended';

export const HD_CIRCUIT_INFO_VARIANTS: readonly HdCircuitInfoVariant[] = [
  'compact',
  'normal',
  'extended',
];

export const HD_CIRCUIT_INFO_DEFAULT_VARIANT: HdCircuitInfoVariant = 'normal';
